module.exports = __webpack_public_path__ + "img/img2.7ba2759c.png";